import Vue from "vue";

/**
 * Class PABX Service
 */
export default class PabxService extends Vue {
  private customActions = {
    lotsIndex: { method: "GET", url: "integration/pabx/lot" },
    sendToPabx: { method: "POST", url: "integration/async/pabx/lead" }
  };
  private resource: any = this.$resource(
    "integration/pabx",
    {},
    this.customActions
  );

  // GET all PABX lots
  public lotsIndex() {
    return this.resource.lotsIndex().then(
      (response: any) => {
        return response.json();
      },
      (response: any) => {
        return response.json();
      }
    );
  }

  public sendToPabx(historyIds: [number?], pabx_lot_id: number, replaceWhenRestRule?: boolean, restRuleInHours?: number) {

    let data: any = {
      historyIds: historyIds,
	    pabx_lot_id: pabx_lot_id
    }

    if (replaceWhenRestRule) data.is_priority = replaceWhenRestRule;
    if (restRuleInHours) data.rest_rule = restRuleInHours;
    return this.resource.sendToPabx({}, data);
  }
}
